import { ApiService } from '@abb-procure/api';
import { Injectable } from '@angular/core';
import { boolean as ioBoolean } from 'io-ts';
import { ApplicationNotification } from '../types/application-notification.type';
import { GlobalNotificationResponse } from '../types/global-notification-response.type';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService extends ApiService {
  async getNotification(): Promise<ApplicationNotification | null> {
    try {
      return this.get<ApplicationNotification>(
        'Notification/Admin',
        ApplicationNotification,
      );
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while retrieving notifications.',
      );
    }
  }

  async getApplicationNotifications(): Promise<GlobalNotificationResponse | null> {
    try {
      return this.get<GlobalNotificationResponse>(
        'Notification',
        GlobalNotificationResponse,
      );
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while retrieving notifications.',
      );
    }
  }

  async confirmNotification(notificationId: string): Promise<boolean | null> {
    try {
      return this.put<boolean, null>(
        `Notification/${notificationId}/Confirm`,
        ioBoolean,
      );
    } catch (error) {
      return this.catchError(
        error,
        'There was an issue while confirming the notification',
      );
    }
  }
}
